// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"d3833141","845":"65aa9bcd"}[chunkId] + ".chunk.js";
};